import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        default_active: 'param',
        is_show_cover: false,
        is_show_authorize: false,
        result: {
            appParam: 0,
            appPage: 0,
            appPay: 0
        },
        data: 0
    },

    getters: {
        showDefaultActive: state => {
            return state.default_active;
        }
    },

    mutations: {
        changeDefaultActive: (state,new_active) => {
            state.default_active = new_active;
        },
        showCoverView: (state) => {
            state.is_show_cover = true;
        },
        closeCoverView: (state) => {
            state.is_show_cover = false;
        },
        showCoverAuthorize: (state, data) => {
            state.is_show_authorize = true;
            state.result = data
        },
        closeCoverAuthorize: (state) => {
            state.is_show_authorize = false;
        },
        changeDataNum: (state, data) => {
            state.data = data
        }
    },
    actions: {
        changeDefaultActive (context,new_cative) {
            context.commit('changeDefaultActive', new_cative)
        },
        showCoverView: (context) => {
            context.commit('showCoverView')
        },
        closeCoverView: (context) => {
            context.commit('closeCoverView')
        },
        showCoverAuthorize: (context, data) => {
            context.commit('showCoverAuthorize', data)
        },
        closeCoverAuthorize: (context) => {
            context.commit('closeCoverAuthorize')
        },
        changeDataNum: (context, data) => {
            context.commit('changeDataNum', data)
        }
    } 
})


// WEBPACK FOOTER //
// ./src/vuex/store/store.js